import { RenovationPlannerSplitTreatments } from '@/store/modules/split/splitFeatureFlags';
import { LocationQuery } from 'vue-router';

export enum RenovationPlannerVariant {
  STACKED_CARDS = 'stacked-cards',
  TABLE_VIEW = 'table-view',
}

export const RENOVATION_PLANNER_VARIANT_QUERY_PARAM = 'renovationPlannerVariant';
export const RENOVATION_PLANNER_SECTION_QUERY_PARAM = 'renovation-planner-section';

export const isRenovationPlannerSectionEnabledFromQuery = (query: LocationQuery): boolean =>
  getSingleQueryValue(query[RENOVATION_PLANNER_SECTION_QUERY_PARAM]) === 'on';

const getSingleQueryValue = (value: LocationQuery[keyof LocationQuery]): string | undefined => {
  const singleValue = Array.isArray(value) ? value[0] : value;
  const trimmedValue = singleValue?.trim();

  return trimmedValue ? trimmedValue : undefined;
};

export const getRenovationPlannerVariantFromQuery = (
  query: LocationQuery,
): RenovationPlannerVariant | undefined => {
  const queryValue = getSingleQueryValue(query[RENOVATION_PLANNER_VARIANT_QUERY_PARAM]);

  if (queryValue === RenovationPlannerVariant.STACKED_CARDS) {
    return RenovationPlannerVariant.STACKED_CARDS;
  }

  if (queryValue === RenovationPlannerVariant.TABLE_VIEW) {
    return RenovationPlannerVariant.TABLE_VIEW;
  }

  return undefined;
};

export const isStackedCardsRenovationPlannerVariant = (
  queryVariant: RenovationPlannerVariant | undefined,
  splitTreatment: string | undefined,
): boolean => {
  if (queryVariant === RenovationPlannerVariant.STACKED_CARDS) {
    return true;
  }

  if (queryVariant === RenovationPlannerVariant.TABLE_VIEW) {
    return false;
  }

  return splitTreatment !== RenovationPlannerSplitTreatments.TABLE_VIEW;
};
